import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  logo: {
    height: '100%',
    width: Theme.px(60),
  },
  logoTime: {
    flexDirection: 'row',
    height: Theme.px(60),
    width: Theme.px(180),
  },
  timeBackground: {
    alignItems: 'center',
    backgroundColor: Theme.withOpacity(Theme.white, 0.1),
    height: '100%',
    justifyContent: 'center',
    width: Theme.px(120),
  },
});
